(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesDialogController', SecurityRolesDialogController);

    SecurityRolesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SecurityRoles'];

    function SecurityRolesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SecurityRoles) {
        var vm = this;

        vm.securityRoles = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.securityRoles.id !== null) {
                SecurityRoles.update(vm.securityRoles, onSaveSuccess, onSaveError);
            } else {
                SecurityRoles.save(vm.securityRoles, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:securityRolesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
